import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { IndexLink, Link } from 'react-router';
import $ from 'jquery';

class MenuLink extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            useHash: false
        }

        this.timer = {};

        if (this.props.to.indexOf('#') !== -1) {
            if (window.location.pathname === '/' + this.props.to.split('#')[0]) {
                this.state.useHash = true;
            }
        }
    }

    componentWillUnmount() {
        if (this.timer.timerID !== undefined) {
            clearTimeout(this.timer.timerID);
        }
    }

    ManualAnchor() {
        if (this.timer.timerID !== undefined) {
            clearTimeout(this.timer.timerID);
        }

        this.timer.timerID = setTimeout(() => {
            try {
                $("html").scrollTop(($("#" + (window.location.hash.substring(1))).offset().top - 72));
                // $("#sideMenu").scrollTop(0)
                // var sideMenu = ($("#sideMenu").offset().top);
                // var menuFind_ = ($("[name=\"menuFind_" + (window.location.hash.substring(1)) + "\"]").offset().top);
                // $("#sideMenu").scrollTop(menuFind_ - sideMenu);
            }
            catch (e) {
            }

        }, 50);
    }

    render() {
        return (
            <div key={this.props.key} name={this.props.name} >
                {
                    this.state.useHash === true ?
                        <a href={this.props.to} onClick={(e) => this.ManualAnchor(e)} >
                            <span className="menuLink" style={{ paddingTop: this.props.small === true ? 5 : 10, paddingLeft: this.props.small === true ? 10 : 20, paddingRight: this.props.small === true ? 5 : 10, paddingBottom: this.props.small === true ? 5 : 10, }}>{this.props.text}</span>
                        </a>
                        :
                        <Link to={this.props.to} className="menuLink" style={{ paddingTop: this.props.small === true ? 5 : 10, paddingLeft: this.props.small === true ? 10 : 20, paddingRight: this.props.small === true ? 5 : 10, paddingBottom: this.props.small === true ? 5 : 10, }} >{this.props.text}</Link>
                }
            </div>
        );
    }
}

export default MenuLink


// WEBPACK FOOTER //
// ./src/components/Menu/MenuLink.js